import {EMode} from "./Mode";

/**
 * Global variables
 */
export class Global {
    private static _mode:EMode = EMode.Live; // system mode

    /**
     * Set mode
     *
     * @param value
     */
    public static set mode(value:EMode) {
        Global._mode = value;
    }

    /**
     * Get mode.
     */
    public static get mode():EMode {
        return Global._mode;
    }
}